import {
  type GroupClassIllustrations,
  GroupSectionListViewCard,
  SkeletonLoader,
} from '@equip.health/ui';
import { GroupTypeTagColorMapper } from '~/lib/constants/groupClasses.constants';
import { SYSTEM_TIME_ZONE } from '~/lib/util/calendar.util';
import {
  formatGroupSectionRecurrence,
  formatGroupSectionTimeSlot,
  formatHosts,
  getFormattedDurationWeeks,
} from '~/lib/util/groups.utils';
import { useGetGroupClassDetailsV2Query } from '~/store/services/groupClass';
import ProviderAvatarTooltipWrapper from '~/components/common/ProviderAvatarBlockTooltipWrapper';

interface PatientRegistrationConfirmationModalV2Props {
  groupId: string;
  selectedSection: SectionData;
}

const PatientRegistrationConfirmationModalV2 = ({
  groupId,
  selectedSection,
}: PatientRegistrationConfirmationModalV2Props) => {
  const { data: groupDetails, isLoading: isFetchingV2 } =
    useGetGroupClassDetailsV2Query(groupId, {
      skip: !groupId,
    });

  return (
    <SkeletonLoader
      id={`${groupId}__skeleton-loader`}
      isLoaded={!isFetchingV2}
      height="100%"
    >
      <GroupSectionListViewCard
        id={selectedSection?.id}
        hosts={formatHosts(selectedSection?.hosts)}
        iconName={groupDetails?.iconName as GroupClassIllustrations}
        groupType={groupDetails?.groupType}
        groupTypeTagColor={GroupTypeTagColorMapper[groupDetails?.groupTypeCode]}
        title={groupDetails?.title}
        timeSlot={formatGroupSectionTimeSlot({
          start: selectedSection?.startDate,
          duration: selectedSection?.duration,
          timeZone: SYSTEM_TIME_ZONE,
        })}
        schedule={formatGroupSectionRecurrence({
          frequency: selectedSection?.frequency,
          start: selectedSection?.startDate,
        })}
        durationWeeks={getFormattedDurationWeeks(selectedSection?.sessionCode)}
        tooltipWrapper={({ children, providerExternalId }) => (
          <ProviderAvatarTooltipWrapper
            actionTime={selectedSection?.startDate}
            isRoleAtAction
            placement="left"
            providerExternalId={providerExternalId}
          >
            {children}
          </ProviderAvatarTooltipWrapper>
        )}
      />
    </SkeletonLoader>
  );
};

export default PatientRegistrationConfirmationModalV2;
